import { object } from "../../helpers/object";
import { debug } from "../../helpers/debug";

import { comparator } from "./comparator";

/*------------------------------------*\
  #COMPARATOR NOTIFICATION
\*------------------------------------*/
class ComparatorNotification {
  constructor(module){
    this.MODULE = module;
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
    this.bottomStackSet = false;
  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    if (!this.DOM_MODULE.length) return;

    document.addEventListener('COMPARATOR_HAS_CHANGER', () => {
      this.refresh();
    });

    this.refresh();

    if(debug.DEBUG) console.log('modules/comparator-notification.js');
  }
  /**
   * Refreshes the comparator banner based on the current items in the comparator.
   * 
   * - Updates the `aria-hidden` attribute of the DOM module based on the number of items.
   * - Adjusts the `bottomStack` property of the page object based on the number of items.
   * - Updates the text content of the items display element to show the current number of items.
   * 
   * @function
   * @name refresh
   */
  refresh = () => {
    const items = comparator.cookieGetIds();
    const itemsLength = items.length;
    const isFilled = itemsLength >= 2;
    const domModule = this.DOM_MODULE[0];
    
    domModule.setAttribute('aria-hidden', isFilled);
    domModule.querySelector('.js-comparator-notification-empty').classList.toggle('u-hidden', isFilled);
    domModule.querySelector('.js-comparator-notification-not-empty').classList.toggle('u-hidden', !isFilled);
    
  }
}
export const comparatorNotification = new ComparatorNotification('[data-js-component="comparator-notification"]'); 